import {ITranslate} from '../../../../_react_/services/LocalizationService';
import {IDomUtilsService} from '@techsee/techsee-client-infra/lib/services/DomUtilsService';
import {observable, action, computed} from 'mobx';
import {ISpeedtestService, ISpeedtestResults} from '../../../../_react_/services/SpeedtestService';

export interface IGuidancePopoversController {
    readonly translate: ITranslate;
    readonly speedtestResults: ISpeedtestResults;
    readonly showSpeedtestResults: boolean;

    loadImage(img: string): string;
    updatePopoverTitle(title: string): void;
    onUpdatePopoverContent(): void;
    speedtestPopoverActivate(): void;
}

export class GuidancePopoversController implements IGuidancePopoversController {
    @observable
    private _speedtestResults?: ISpeedtestResults;

    constructor(
        public translate: ITranslate,
        private domUtilsService: IDomUtilsService,
        private speedtestService: ISpeedtestService,
        private _mobileSpeedtestOoklaPremium: boolean,
        private _mobileSpeedtestDefaultProvider: boolean
    ) {
        if (this.showSpeedtestResults) {
            this.speedtestService.onResultsProcessed((results: ISpeedtestResults) => {
                this.setSpeedtestResults(results);
                this.speedtestPopoverActivate();
            });
        }
    }

    loadImage(img: string) {
        return this.domUtilsService.loadImage(img);
    }

    @computed
    get speedtestResults(): any {
        return this._speedtestResults;
    }

    @computed
    get showSpeedtestResults(): any {
        return this._mobileSpeedtestOoklaPremium || this._mobileSpeedtestDefaultProvider;
    }

    @action
    setSpeedtestResults(speedtestResults: ISpeedtestResults) {
        this._speedtestResults = speedtestResults;
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    updatePopoverTitle(title: string): void {}

    onUpdatePopoverContent(): void {}

    speedtestPopoverActivate(): void {}
}
